var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "currency-cell",
      class: [
        _vm.field.alignment,
        { outlined: _vm.outlined, readonly: _vm.readonly },
      ],
      on: { dblclick: _vm.enableEdit },
    },
    [
      _vm.editing
        ? [
            _c("a-input-number", {
              staticClass: "borderless-input",
              attrs: {
                formatter: _vm.formatterWithoutSymbol,
                parser: _vm.parser,
              },
              on: {
                blur: _vm.disableEdit,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.disableEdit.apply(null, arguments)
                },
              },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            }),
          ]
        : [_vm._v("\n        " + _vm._s(_vm.formattedValue) + "\n    ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }